import { useEffect, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { LinkButton } from '@/atoms/Button'
import { CelebrationIcon } from '@/atoms/Icons/CelebrationIcon'
import { CheckIcon } from '@/atoms/Icons/CheckIcon'
import { LoadingSpinnerIcon } from '@/atoms/Icons/LoadingSpinnerIcon'
import { HeadingMD, ParagraphLG, ParagraphMD } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { useTranslate } from '@/utils/translate/translate-client'
import { preparedDashboardTexts } from './constants'

const getNextPreparedText = () => {
  const dashboardText = preparedDashboardTexts[Math.floor(Math.random() * preparedDashboardTexts.length)]
  return (
    <motion.div
      key={dashboardText}
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      exit={{ opacity: 0, left: 200 }}
      transition={{ duration: 0.5 }}
      layout
      className="relative inset-x-0 py-3 text-center text-core-gray-500"
    >
      <ParagraphMD className="text-sm">...{dashboardText}...</ParagraphMD>
    </motion.div>
  )
}

export const SubmissionSuccess = () => {
  const { t } = useTranslate('guild-create')
  const [ready, setReady] = useState(false)
  const [prepText, setPrepText] = useState(getNextPreparedText())

  useEffect(() => {
    const interval = setInterval(() => {
      setPrepText(getNextPreparedText())
    }, 3000)
    const readyInterval = setInterval(() => {
      setReady(true)
    }, 10000)
    return () => {
      clearInterval(interval)
      clearInterval(readyInterval)
    }
  }, [])

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="flex flex-col items-center">
        <CelebrationIcon color="oxide" size={92} />
        <HeadingMD weight="bold" className="text-center">
          {t('almostDone', 'Application Submitted!')}
        </HeadingMD>
      </div>
      <ParagraphLG className="text-center font-semibold">
        {t('visitYourFilmmakerDashboard', 'Visit your filmmaker dashboard to:')}
      </ParagraphLG>
      <ul className="list-disc">
        <li>Track your score</li>
        <li>Read feedback</li>
        <li>Respond to voters</li>
      </ul>
      <AnimatePresence>
        {!ready && (
          <motion.div key="readyDiv" exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.75 }}>
            <ParagraphLG weight="semibold" className="text-center">
              Sit tight while we get it prepared!
            </ParagraphLG>
            <div className="relative w-full">
              <AnimatePresence exitBeforeEnter={true} presenceAffectsLayout={true}>
                {prepText}
              </AnimatePresence>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <LinkButton disabled={!ready} variant="oxide" href={paths.guild.create.status}>
        <div className="flex items-center gap-2">
          {ready ? <CheckIcon size={24} /> : <LoadingSpinnerIcon />}
          <ParagraphMD>{t('goToFilmmakerDashboard', 'Go to Dashboard')}</ParagraphMD>
        </div>
      </LinkButton>
    </div>
  )
}
